<template>
    <th
        :class="{
            'hover': hover,
            'sort-active': isSortActive,
            'flex-table-no-wrap': !column.wrapText,
        }"
        :style="{
            width: column.width,
        }"
        @mouseover="onMouseOver"
        @mouseout="onMouseOut"
        @click="onClick"
    >
        <template v-if="column.columnTemplate">
            <column-template :column="column" :rows="rows" />
        </template>
        <template v-else>
            {{ column.label }}
        </template>

        <i v-show="showSortDesc" class="fa-solid fa-caret-down sort-icon" />
        <i v-show="showSortAsc" class="fa-solid fa-caret-up sort-icon" />
    </th>
</template>

<script>
import { flipOrder } from '../util/helpers';

export default {
    components: {
        ColumnTemplate: {
            functional: true,
            render: (h, { props }) => props.column.columnTemplate(props),
        },
    },
    props: {
        column: Object,
        rows: Array,
        sort: Object,
    },
    data() {
        return {
            hover: false,
        };
    },
    computed: {
        showSortAsc() {
            return this.getVisibleSortIcon('asc');
        },
        showSortDesc() {
            return this.getVisibleSortIcon('desc');
        },
        isSortActive() {
            return this.column.name === this.sort.name;
        },
        isSortable() {
            return this.column.isSortable();
        },
    },
    methods: {
        getVisibleSortIcon(order) {
            if (this.isSortActive) {
                if (this.hover) {
                    return this.sort.order === flipOrder(order);
                } else {
                    return this.sort.order === order;
                }
            } else if (this.hover && this.sort.order === order) {
                return true;
            } else {
                return false;
            }
        },
        onClick() {
            if (this.isSortable) {
                this.$emit('sort', this.column);
            }
        },
        onMouseOver() {
            if (this.isSortable) {
                this.hover = true;
            }
        },
        onMouseOut() {
            if (this.isSortable) {
                this.hover = false;
            }
        },
    },
};
</script>
